import _ from 'lodash';

const getters = {
  activeSite(state) {
    return state.activeSite || window.localStorage.activeSite;
  },
  activeSiteObject(state) {
    return _.find(getters.sites(state), { id: getters.activeSite(state) });
  },
  activeUser(state) {
    if (state.activeUser) {
      return state.activeUser;
    }

    try {
      return JSON.parse(window.localStorage.activeUser);
    } catch (error) {
      return null;
    }
  },
  authToken(state) {
    return state.authToken || window.localStorage.authToken;
  },
  permissions(state) {
    if (state.permissions && state.permissions.length > 0) {
      return state.permissions;
    }

    try {
      return JSON.parse(window.localStorage.permissions);
    } catch (error) {
      return null;
    }
  },
  sites(state) {
    if (state.sites && state.sites.length > 0) {
      return state.sites;
    }

    try {
      return JSON.parse(window.localStorage.sites);
    } catch (error) {
      return null;
    }
  },
  groupReportSites(state) {
    if (state.groupReportSites && state.groupReportSites >= 1) {
      return state.groupReportSites;
    }

    try {
      return JSON.parse(window.localStorage.groupReportSites);
    } catch (error) {
      console.log('groupReportSites excepted and returned []');
      return [];
    }
  },
};

export default getters;
